import { Link as RouterLink } from 'react-router-dom';
import { Button, useTranslate } from 'react-admin';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

export const GenerateButton = ({ total }: { total?: number }) => {
    const translate = useTranslate();
    const to = total ? `generate?total=${total}` : 'generate';

    return (
        <Button
            component={RouterLink}
            to={to}
            label={translate('app.action.generate')}
            startIcon={<PlaylistAddIcon />}
        />
    );
};
